import { render, staticRenderFns } from "./AddWe.vue?vue&type=template&id=789d85e4&scoped=true&"
import script from "./AddWe.vue?vue&type=script&lang=js&"
export * from "./AddWe.vue?vue&type=script&lang=js&"
import style0 from "./AddWe.vue?vue&type=style&index=0&id=789d85e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d85e4",
  null
  
)

export default component.exports